// Making a new JS component
// 1 - Replace map with new name ( 8 occurences in this file )
// 2 - All code goes into init()
// 3 - Save file as new name .js
var gMap = {
	name: 'gMap',
	componentInitSelector: '.gMap',
	registerComponent: function() {
		if ( $(gMap.componentInitSelector).length ) {
			framework.registerComponent(gMap);
		}
	},
	initmap: function() {
		$.each($(gMap.componentInitSelector), function( index, mapInstance ) {

			var data = gMapData;

			buildMap = function() {
				// log(data.Options.CenterLng)

				var myLatLng = {lat: data.Options.centerLat, lng: data.Options.centerLng};

				map = new google.maps.Map(document.getElementById(mapInstance.id), {
			    	center: myLatLng,
			        zoom: 15,
					zoomControlOptions: {
						position: google.maps.ControlPosition.LEFT_BOTTOM
					},
			        streetViewControl: false,
			        scrollwheel: false,
				    styles: [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#F1F2F4"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#F1F2F4"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#F1F2F4"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]
			    });

			    var markerCoordsArray = [];

 				$.each(data.Markers, function( index, markerInstance ) {

			    	var markerLatLng = {lat: markerInstance.lat, lng: markerInstance.lng};

			    	// Add these coords to array for the custom accordion clicks
			    	markerCoordsArray.push(markerLatLng);

		    		var marker = new google.maps.Marker ({
				        position: markerLatLng,
				        map: map,
				        icon: markerInstance.marker,
			         	targetAccordion: markerInstance.targetAccordion
				    });
				});
		 	}

		 	buildMap();
		 	// End
        	log(config.application.name + " •• map in " + Math.round( performance.now() - framework.initComponents.componentInitTime) + " milliseconds" );
		});
    },
    init: function() {
        // All code for this component goes in here
        // https://developers.google.com/maps/faq?hl=en#china_ws_access

        if ( typeof(isCHINA) == 'undefined' ) {
        	log(config.application.name + " •• map is loading default scripts");
        	loadScript("//maps.googleapis.com/maps/api/js?key=AIzaSyDUwNLS8uR4xRTpevzd205NltRpndCHrNo", gMap.initmap);
        } else {
        	log(config.application.name + " •• map is loading CHINA scripts");
        	loadScript("http://maps.google.cn/maps/api/js?key=AIzaSyDUwNLS8uR4xRTpevzd205NltRpndCHrNo", gMap.initmap);
        }
    }
}

// Register self to the framework
gMap.registerComponent();
